export default "__VITE_ASSET__BouS0wPB__"